import styled from "@emotion/styled";
import { css } from "@emotion/react";
import {
    colorVariables,
    fontSizes,
    gutterSizes,
    boxSizes,
    colors,
    fontWeights,
} from "@gumtree/ui-library/src/base/theme";

export const Container = styled.div`
    padding: 0 ${gutterSizes.medium} ${gutterSizes.medium} ${gutterSizes.medium};

    .motors-cta {
        font-weight: ${fontWeights.bold};
    }
`;

export const ErrorMessage = styled.div`
    padding: 8px 0;
    color: ${colors.red};
`;

export const ToggleContent = styled.div<{ isOpen: boolean }>`
    display: none;

    ${({ isOpen }) =>
        isOpen &&
        css`
            display: block;
            border: 1px solid ${colorVariables.borderLight};
            padding: ${gutterSizes.medium};
            border-radius: ${boxSizes.borderRadius};
            margin-top: ${gutterSizes.medium};

            & .button-group {
                border-top: none;
            }

            & textarea {
                margin-top: ${gutterSizes.base};
                height: 75px;
                font-size: ${fontSizes.base};
                $gutter-size: ${gutterSizes.base};
            }
        `}
`;
